import { Icon } from '@iconify/react'
import { FC } from 'react'

import StatCard from '../StatCard/StatCard'

import s from './InfoCard.module.css'

type Props = {
  traffic: {
    value: number
    growth_percentage: number
    average_value: number
  }
}

const InfoCard: FC<Props> = ({ traffic }) => {
  const savings = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(traffic.value)

  return (
    <div className={s.wrapper}>
      <div className={s.title}>
        <Icon icon="lucide-sparkles" />
        {`Your organic search efforts have resulted in a remarkable cost savings of ${savings} worth of paid ads.`}
      </div>
      <div className={s.body}>
        <StatCard
          title="Organic Search Traffic Value"
          value={traffic.value}
          isCurrency={true}
          change={traffic.growth_percentage}
        />
        <StatCard
          title="Average CPC"
          value={traffic.average_value}
          isCurrency={true}
        />
      </div>
    </div>
  )
}

export default InfoCard
